module.exports = __webpack_public_path__ + "../resources/img/ic_re_partly_cloudy_day_solid.9ede3797.svg";